__turbopack_context__.v({
  "heroInfoTabs": "HeroInfoTabs-module-scss-module__EXiuha__heroInfoTabs",
  "heroInfoTabs__item": "HeroInfoTabs-module-scss-module__EXiuha__heroInfoTabs__item",
  "heroInfoTabs__item_active": "HeroInfoTabs-module-scss-module__EXiuha__heroInfoTabs__item_active",
});
